import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "emptyState", "input", "item"]

  connect() {
    this.filter()
  }

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    let visibleItems = 0

    this.itemTargets.forEach((item) => {
      const text = item.dataset.searchText || ""
      const matches = query === "" || text.includes(query)

      item.classList.toggle("hidden", !matches)
      visibleItems += matches ? 1 : 0
    })

    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.toggle("hidden", visibleItems > 0)
    }
  }
}
